import { Component } from '@angular/core';

@Component({
  selector: 'app-enabled-facilitator',
  templateUrl: './enabled-facilitator.component.html',
  styleUrls: ['./enabled-facilitator.component.scss']
})
export class EnabledFacilitatorComponent {

}
